/**
 * Language bootstrap — MUST be imported before any module that resolves
 * bilingual data at load time (e.g. @/data/applicationCases, @/data/companyNews
 * eagerly call localizedText()). It makes the URL the source of truth for the
 * active language so that `/ko/...` pages render Korean regardless of the
 * stored/browser preference.
 *
 * ES module imports execute in order, so importing this first in main.ts
 * guarantees the language is set before the data modules evaluate.
 */
import { parsePath } from './lang'
import { i18n } from './i18n'

const { lang } = parsePath(window.location.pathname)
i18n.setLanguage(lang)
